
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import useBranchDeployerDialog from "./useBranchDeployerDialog";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const BranchDeployerDialog = ({
  open,
  type,
  data,
  onClose,
  onSubmit
}) => {
  const { dialogContent } = useBranchDeployerDialog({ type, data });
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveButtonClicked = async () => {
    setIsLoading(true);
    await onSubmit(data, type);
    setIsLoading(false);
  };

  return (
    <Dialog
      open={open}
      title={dialogContent.title}
      onClose={onClose}
    >
      <DialogTitle>{dialogContent?.title}</DialogTitle>
      <DialogContent>
        <Typography
          style={{ whiteSpace: "pre-line" }}
          variant="body1"
          color="text.800"
        >
          {dialogContent?.subtitle}
        </Typography>
      </DialogContent>
      <DialogActions>
        <HyroButton variant={BUTTON_VARIANTS.TEXT} color={BUTTON_COLORS.SECONDARY} data-testid={`cancel-${type}-bd-button`} onClick={onClose}>Cancel</HyroButton>
        <HyroButton
          data-testid={`${type}-bd-button`}
          variant={BUTTON_VARIANTS.CONTAINED}
          onClick={handleSaveButtonClicked}
          loading={isLoading}
        >
          {dialogContent.actionButtonText}
        </HyroButton>
      </DialogActions>
    </Dialog>
  );
};

export default BranchDeployerDialog;
